import { Controller } from "@hotwired/stimulus"
import Sortable from 'sortablejs'

export default class AdminMiniContentListController extends Controller {
  connect() {
    this.handleSortingMiniContentList()
  }

  handleSortingMiniContentList() {
    const sortable = Sortable.create(this.element, {
      sort: true,
      draggable: '.list'
    })
    sortable.option("onUpdate", () => {
      fetch("/admin/mini_content_positions", {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
        },
        body: JSON.stringify({
          new_position_ids: getNewPositionIds()
        })
      })
      .then(resp => {
        if (!resp.ok) {
          throw new Error("Something went wrong while updating the position")
        }
      })
    })

    function getNewPositionIds() {
      return sortable.toArray()
    }
  }
}
